import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { AutocompleteControl } from 'components/_basic/Form/Autocomplete';

import { getIndustryOptions } from 'helpers/industryOperationOptions';

import {
  COMPANY_INDUSTRY_GROUP_FIELD_NAME,
  INDUSTRY_FIELD_NAME,
  SECTOR_FIELD_NAME,
  SUB_SECTOR_FIELD_NAME,
} from '../../form';
import { IIndustryDropdownProps as IProps } from '../types';

export const IndustryDropdown: FC<IProps> = ({ disabled, id }) => {
  const { t, i18n } = useTranslation();
  const { control } = useFormContext();

  const [sectorValue, subSectorValue, industryGroupValue] = useWatch({
    name: [SECTOR_FIELD_NAME, SUB_SECTOR_FIELD_NAME, COMPANY_INDUSTRY_GROUP_FIELD_NAME],
  });

  const industryOptions =
    getIndustryOptions(industryGroupValue, i18n.language) ??
    getIndustryOptions(subSectorValue, i18n.language) ??
    getIndustryOptions(sectorValue, i18n.language) ??
    [];

  if ((industryGroupValue || subSectorValue || sectorValue) && industryOptions.length) {
    return (
      <Grid item xs={12}>
        <AutocompleteControl
          control={control}
          label={t('industry')}
          id={id ?? INDUSTRY_FIELD_NAME}
          name={INDUSTRY_FIELD_NAME}
          options={industryOptions}
          disabled={disabled}
        />
      </Grid>
    );
  }

  return null;
};
